// Keys for feature flags found in featurehub
export enum FeatureFlag {
  RELEASE_DOCUMENT_AUTOMATION = "release__document_automation",
  RELEASE_CREATE_TEMPLATE_FIELDS = "release__create_template_fields",
  RELEASE_CREATE_DEFINED_ENVELOPES = "release__create_defined_envelopes",
  RELEASE_DOCUMENT_AUTOFILL = "release__bridgev2_document_autofill",
  RELEASE_PROPERTY_PAGE = "release__bridge2_property_page",
}
